export default {
    relatorioRede: state => state.relatorioRede,
};
